import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Observable } from 'rxjs/Observable';
import { Cita } from '../models/';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class CitasService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * obtenerCitas: obtiene el listado completo de citas
   * @param cip: string
   * @return any
   */
  obtenerCitas(cip: string): any {
    let params: any = { CIP: cip };
    return this._http.post(environment.api_host + 'citas/obtenerCitasPendientes', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerFechasHueco(cip: string, agenda: string, fecha: string): any {
    let params: any = {
      demandante: cip,
      agenda: agenda,
      fecha: this.formatearFecha(fecha),
    };
    return this._http.post(environment.api_host + 'citas/obtenerFechasHueco', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerHuecos(cip: string, agenda: string, fecha: string): any {
    let params: any = {
      demandante: cip,
      agenda: agenda,
      fecha: this.formatearFecha(fecha),
    };
    return this._http.post(environment.api_host + 'citas/obtenerHuecos', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * incluirCita
   * @param pacienteId: string
   * @param cita: Cita
   * @return JSON Object
   */
  confirmarCita(cip: string, agenda: string, fecha: string, hora: string): any {
    let params: any = {
      demandante: cip,
      agenda: agenda,
      fecha: this.formatearFecha(fecha),
      hora: this.formatearHora(hora),
    };
    return this._http.post(environment.api_host + 'citas/confirmar', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * eliminarCita
   * @param pacienteId: string
   * @param citaId: string
   * @return JSON Object
   */
  eliminarCita(citaId: string, cip: string): any {
    let params: any = {
      id: citaId,
      demandante: cip,
    };
    return this._http.post(environment.api_host + 'citas/eliminar', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * Formatea una fecha para los REST
   * @param fecha Cadena en formato JS
   * @return string Fecha formateada
   */
  private formatearFecha(fecha: string): string {
    let nuevaFecha: string[] = fecha.split('/');
    if (nuevaFecha[0].length === 1) {
      nuevaFecha[0] = '0' + nuevaFecha[0];
    }
    if (nuevaFecha[1].length === 1) {
      nuevaFecha[1] = '0' + nuevaFecha[1];
    }
    return nuevaFecha[0] + nuevaFecha[1] + nuevaFecha[2];
  }

  /**
   * Formatea una hora para los REST
   * @param hora Cadena con :
   * @return string Hora formateada sin :
   */
  private formatearHora(hora: string): string {
    let nuevaHora: string[] = hora.split(':');
    return `${nuevaHora[0]}${nuevaHora[1]}`;
  }
}



// WEBPACK FOOTER //
// ./src/services/citas.service.ts